<template>
  <div
    class="ss__custom__header__notice"
    tabindex="-1"
    @mouseenter="open"
    @mouseleave="close">
    <SsButton2
      type="text"
      class="ss__custom__header__btn__notice">
      <i class="ssCommunityIcon__subscribe"></i>
      <i class="ss__custom__header__notice__count" v-if="amount">{{ amount }}</i>
    </SsButton2>

    <transition name="ss__custom__header__fade">
      <SsNotificationsPopover
        v-show="visible"
        class="comp__SsNotificationsPopover"
        :style="{
          left: `${offsetLeft}px`,
          top: `${offsetTop}px`
        }"
        :notifications="notifications"
      />
    </transition>

    <SafeArea
      v-if="visible"
      :svgWidth="298"
      :left="offsetLeft"
      :mouseX="mouseX"
      :mouseY="mouseY"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import SafeArea from '../SafeArea/index.vue'
import SsButton2 from '../SsButton2'
import SsNotificationsPopover from '../SsNotificationsPopover'

export default {
  name: 'SsCustomHeaderNotice',

  components: {
    SafeArea,
    SsButton2,
    SsNotificationsPopover
  },

  props: [
    'userInfo',
    'noticeCount',
    'visible'
  ],

  data () {
    return {
      offsetLeft: 0,
      offsetTop: 0,
      mouseX: 0,
      mouseY: 0
    }
  },

  computed: {
    // 未读消息数量
    amount () {
      if (!this.noticeCount) return 0
      const {
        online_count: reaction = 0,
        comment_count: comment = 0,
        system_count: system = 0,
        community_comment_count: community = 0,
        message_count: message = 0
      } = this.noticeCount || {}
      const count = reaction + comment + system + community + message
      if (count > 99) {
        return '99+'
      }
      return count
    },
    notifications () {
      const {
        online_count: reaction = 0,
        comment_count: comment = 0,
        system_count: system = 0,
        community_comment_count: community = 0,
        message_count: message = 0
      } = this.noticeCount || {}
      return {
        reaction,
        comment,
        system,
        community,
        message
      }
    }
  },

  methods: {
    open () {
      const btn = document.querySelector('.ss__custom__header__btn__notice')
      const { left: leftRef, top: topRef, width: widthRef, height: heightRef } = btn.getBoundingClientRect()
      const widthTarget = 298
      if (!('ontouchstart' in window)) {
        this.offsetLeft = leftRef - widthTarget + widthRef
      } else {
        this.offsetLeft = window.innerWidth - widthTarget - 24
      }
      this.offsetTop = topRef + heightRef
      this.$emit('update:visible', true)
      dispatchEvent(new CustomEvent('ssCustomHeaderToggleTarget', { detail: 'notice' }))
    },
    close () {
      this.$emit('update:visible', false)
    },
    updateMousePosition: debounce(function (e) {
      this.mouseX = e.clientX
      this.mouseY = e.clientY - 4
    }, 30)
  },

  mounted () {
    window.addEventListener('mousemove', this.updateMousePosition)
  },

  destoryed () {
    window.removeEventListener('mousemove', this.updateMousePosition)
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'

.ss__custom__header__notice {
  .ss__custom__header__btn__notice {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--w-ssCustonHeaderBtnNotice, 32px);
    height: var(--h-ssCustonHeaderBtnNotice, 32px);
    i {
      font-size: var(--size-ssCustonHeaderNoticeIcon, 20px);
      color: var(--color-ssCustonHeaderNoticeIcon, var(--B8-t));
    }
    .ss__custom__header__notice__count {
      position: absolute;
      top: 4px;
      left: 60%;
      display: inline-block;
      transform: scale(.7) translate(-50%, -50%);
      font-style: normal;
      font-size: 12px;
      line-height: 18px;
      font-weight: 600;
      padding: 0 4px;
      min-width: 12px;
      color: #fff;
      background: var(--red-t);
      border-radius: 20px;
      border: 2px solid var(--color-ssCustomHeader-bg, var(--B0-t));
    }
  }

  .comp__SsNotificationsPopover {
    position: fixed;
    padding-top: 8px;
    z-index: 3;
  }
}
</style>
